import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

type ComponentExport<T> = Extract<T, ComponentType>;

/**
 * Ленивая страница маршрута из именованного экспорта модуля-группы: `lazyRoute(loadWorkspacePages, 'Documents')`.
 * Группа (`router/lazy/*Pages.ts` приложения) — один чанк на несколько страниц.
 */
export const lazyRoute = <TModule, TExport extends keyof TModule>(
    loadModule: () => Promise<TModule>,
    exportName: TExport,
): LazyExoticComponent<ComponentExport<TModule[TExport]>> =>
    lazy(async () => ({
        default: (await loadModule())[exportName] as ComponentExport<TModule[TExport]>,
    }));
